import React from "react";
import { useTranslation } from "react-i18next";

import { TextSection } from "../../components/expretise/TextSection";
import DomainesIntervention from "../../components/expretise/DomainesIntervention";
import SlideGenerale from "../../components/expretise/slideGenarale";
import SEO from "../../components/SEO";

import img from "../../assets/images/consulting-bg.png";
import text from "../../assets/images/text.png";

import { CercleIcon } from "../../assets/icons/CercleIcon";
import { Parametre } from "../../assets/icons/Parametre";
import { CardIcon } from "../../assets/icons/CardIcon";

export const Consulting = () => {
  const { t } = useTranslation();

  const cards = [
    {
      id: 1,
      icon: <CardIcon />,
      title: t("consulting.cards.1.title"),
      description: t("consulting.cards.1.description"),
      backContent: t("consulting.cards.1.backContent", { returnObjects: true }),
    },
    {
      id: 2,
      icon: <CercleIcon />,
      title: t("consulting.cards.2.title"),
      description: t("consulting.cards.2.description"),
      backContent: t("consulting.cards.2.backContent", { returnObjects: true }),
    },
    {
      id: 3,
      icon: <Parametre />,
      title: t("consulting.cards.3.title"),
      description: t("consulting.cards.3.description"),
      backContent: t("consulting.cards.3.backContent", { returnObjects: true }),
    },
    {
      id: 4,
      icon: <CardIcon />,
      title: t("consulting.cards.4.title"),
      description: t("consulting.cards.4.description"),
      backContent: t("consulting.cards.4.backContent", { returnObjects: true }),
    },
    {
      id: 5,
      icon: <CercleIcon />,
      title: t("consulting.cards.5.title"),
      description: t("consulting.cards.5.description"),
      backContent: t("consulting.cards.5.backContent", { returnObjects: true }),
    },
    {
      id: 6,
      icon: <Parametre />,
      title: t("consulting.cards.6.title"),
      description: t("consulting.cards.6.description"),
      backContent: t("consulting.cards.6.backContent", { returnObjects: true }),
    },
  ];

  return (
    <div>
      <SEO
        title="MSIT Advisory - Conseil en Transformation Digitale"
        description="MSIT Advisory offre des services de conseil en transformation digitale, stratégie d'entreprise et optimisation des processus. Expertise en conseil stratégique et opérationnel."
        keywords="conseil transformation digitale, MSIT advisory, conseil stratégique, conseil opérationnel, transformation digitale"
        url="https://www.msit-conseil.fr/bu-msit-advisory"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "MSIT Advisory", url: "https://www.msit-conseil.fr/bu-msit-advisory" }
        ]}
      />
      <SlideGenerale
        headerBg="bg-dark"
        bgColor="bg-primary"
        sectionClass="consulting-section"
        bgImage={img}
        infos={t("consulting.infos", { returnObjects: true })}
        title={t("consulting.title")}
        description={t("consulting.description")}
      />
      <TextSection image={text} />
      <DomainesIntervention cards={cards} />
    </div>
  );
};
